export const SET_DELIVERY_PARTNER_DATA = 'SET_DELIVERY_PARTNER_DATA';